import styled from '@emotion/styled'

import { getUrlByDomain } from '@js/common/getUrlByDomain'

import { InternalLinkWithWT } from '@f-fertighaus/applications/Next/components/common/InternalLink'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'

export const ReturnToHouseSearchButton = () => {
  const { domain } = useHouseDetail()

  return (
    <ButtonContainer>
      {document.referrer.includes(getUrlByDomain(domain)('houseList')()) && (
        <InternalLinkWithWT
          arrowDirection={InternalLinkWithWT.arrowDirection.left}
          wtPayload={{
            category: 'CTA-link',
            action: 'click',
            label: 'return-to-search-results',
            location: 'house-detail-content-end',
            values: [
              { type: 'url', value: document.referrer },
              {
                type: 'text',
                value: t('houseDetailPage.return-to-house-search')
              }
            ]
          }}
          href={document.referrer}>
          <p>{t('houseDetailPage.return-to-house-search')}</p>
        </InternalLinkWithWT>
      )}
    </ButtonContainer>
  )
}

const ButtonContainer = styled('div')`
  grid-area: footer;
  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
  position: absolute;
  top: -64px;
  left: 0;
  right: 0;
`
